function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslate } from 'shared/helper/translate';
import { parseValidators } from '../util';
import FormRow from './FormRow';
var Text = function Text(_ref) {
  var description = _ref.description,
    label = _ref.label,
    messages = _ref.messages,
    name = _ref.name,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    validators = _ref.validators,
    required = _ref.required,
    maxLength = _ref.maxLength,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    _ref$onBlur = _ref.onBlur,
    _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    children = _ref.children,
    disabled = _ref.disabled,
    tooltip = _ref.tooltip;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useFormContext = useFormContext(),
    register = _useFormContext.register;
  var registerProps = register(name, parseValidators({
    messages: messages,
    validators: validators
  }));
  return /*#__PURE__*/React.createElement(FormRow, {
    messages: messages,
    required: typeof required !== 'undefined' ? required : !!validators,
    name: name,
    label: label,
    styles: styles,
    description: description
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: "form-control ".concat(styles && styles.controlClass ? styles.controlClass : ''),
    readOnly: readOnly,
    type: type,
    maxLength: maxLength,
    placeholder: t(placeholder || '')
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, registerProps, {
    onBlur: function onBlur() {
      _onBlur.apply(void 0, arguments);
      return registerProps.onBlur.apply(registerProps, arguments);
    },
    "data-cy": name,
    disabled: disabled,
    title: tooltip || ''
  })), children);
};
export default Text;